import { core, dateUtil } from '@/core'
import Basic from '@basic'
import { Input, DatePanel, TimePanel } from '@bag'

const kickInputMode = {
  Y: {
    type: 'text',
    placeholder: '选择年',
    readonly: true,
    clearable: true,
    prefix: 'calendar',
    level: 0,
  },
  W: {
    type: 'text',
    placeholder: '选择周',
    readonly: true,
    clearable: true,
    prefix: 'calendar',
  },
  M: {
    type: 'text',
    placeholder: '选择年月',
    readonly: true,
    clearable: true,
    prefix: 'calendar',
    level: 1,
  },
  D: {
    type: 'text',
    placeholder: '选择日期',
    readonly: true,
    clearable: true,
    prefix: 'calendar',
  },
  TH: {
    type: 'text',
    placeholder: '选择日期时间',
    readonly: true,
    clearable: true,
    prefix: 'clock-o',
  },
  TM: {
    type: 'text',
    placeholder: '选择日期时间',
    readonly: true,
    clearable: true,
    prefix: 'clock-o',
  },
  TS: {
    type: 'text',
    placeholder: '选择日期时间',
    readonly: true,
    clearable: true,
    prefix: 'clock-o',
  },
  H: {
    type: 'text',
    placeholder: '选择时间',
    readonly: true,
    clearable: true,
    prefix: 'clock-o',
  },
  HM: {
    type: 'text',
    placeholder: '选择时间',
    readonly: true,
    clearable: true,
    prefix: 'clock-o',
  },
  HMS: {
    type: 'text',
    placeholder: '选择时间',
    readonly: true,
    clearable: true,
    prefix: 'clock-o',
  },
}

const kickPanelMode = {
  Y: {
    lvl: 0,
    level: 0,
  },
  W: {},
  M: {
    lvl: 1,
    level: 1,
  },
  D: {},
  TH: {
    timeHead: true,
    footer: true,
    showSeconds: false,
  },
  TM: {
    timeHead: true,
    footer: true,
    showSeconds: false,
  },
  TS: {
    footer: true,
    timeHead: true,
  },
  H: {
    showSeconds: false,
  },
  HM: {
    showSeconds: false,
  },
  HMS: {
    showSeconds: true,
  },
}

const kickValueMode = {
  Y(value) {
    return this.date(value)
  },
  W(value) {},
  M(value) {
    return this.date(value)
  },
  D(value) {
    return this.date(value)
  },
  TH(value) {
    return this.datetime(value)
  },
  TM(value) {
    return this.datetime(value)
  },
  TS(value) {
    return this.datetime(value)
  },
  H(value) {
    return this.time(value)
  },
  HM(value) {
    return this.time(value)
  },
  HMS(value) {
    return this.time(value)
  },
  datetime(value) {
    const [v1 = '', v2 = ''] = value.split(' ')
    const [y = 2020, m = 1, d = 1] = v1.split('-')
    const [hh = 0, mm = 0, ss = 0] = v2.split(':')
    return new Date(y * 1, m * 1 - 1, d * 1, hh * 1, mm * 1, ss * 1, 0)
  },
  date(value) {
    const [y = 2020, m = 1, d = 1] = value.split('-')
    return new Date(y * 1, m * 1 - 1, d * 1)
  },
  time(value) {
    const [hh = 0, mm = 0, ss = 0] = value.split(':')
    return new Date(2020, 0, 1, hh * 1, mm * 1, ss * 1, 0)
  },
}

const formateDate = {
  Y(value) {
    return dateUtil.formateYear(value)
  },
  W(value) {},
  M(value) {
    return dateUtil.formateMonth(value)
  },
  D(value) {
    return dateUtil.formateDate(value)
  },
  TH(value) {
    return dateUtil.formateDateTime3(value)
  },
  TM(value) {
    return dateUtil.formateDateTime2(value)
  },
  TS(value) {
    return dateUtil.formateDateTime1(value)
  },
  H(value) {
    return dateUtil.formateTime3(value)
  },
  HM(value) {
    return dateUtil.formateTime2(value)
  },
  HMS(value) {
    return dateUtil.formateTime1(value)
  },
}

const util = {
  pullPanel(opt, tar) {
    const { mode } = opt
    const option = this.kickPanel(mode)
    if (['HMS', 'HM', 'H'].includes(mode)) {
      const panel = new TimePanel(Object.assign({}, opt, option))
      $('body').append(panel.unit)
      return panel
    } else {
      const panel = new DatePanel(Object.assign({}, opt, option))
      $('body').append(panel.unit)
      return panel
    }
  },
  pullInput(opt, tar) {
    const { showIcon, mode } = opt
    const option = this.kickInput(mode)
    tar._prefix = option.prefix
    const input = new Input(Object.assign({}, opt, option))
    input.unit.addClass('date-editor date-editor--date')
    tar.unit = input.unit
    return input
  },
  kickInput(mode) {
    const opt = kickInputMode[mode] || {}
    return Object.assign({}, opt)
  },
  kickPanel(mode) {
    const opt = kickPanelMode[mode] || {}
    return Object.assign({}, opt)
  },
  kickValue(mode, value) {
    return (
      ($.type(kickValueMode[mode]) === 'function' &&
        kickValueMode[mode](value)) ||
      new Date()
    )
  },
  kickFormate(mode, value) {
    return (
      ($.type(formateDate[mode]) === 'function' && formateDate[mode](value)) ||
      ''
    )
  },
  updater: {
    // 原生类
    name(value, opt, tar, node) {
      tar.input.name = value
    },
    disabled(value, opt, tar, node) {
      tar.input.disabled = value
    },
    placeholder(value, opt, tar, node) {
      tar.input.placeholder = value
    },
    // 基本类
    size(value, opt, tar, node) {
      tar.input.size = value
    },
    showIcon(value, opt, tar, node) {
      if (value) {
        tar.input.prefix = tar._prefix
      } else {
        tar._prefix = tar.input.prefix
        tar.input.prefix = ''
      }
    },
    date(value, opt, tar, node) {
      tar.panel.date = tar.panel.value = value
    },
    // 扩展类
    isRange(value, opt, tar, node) {
      // TODO:未完成
    },
    clearable(value, opt, tar, node) {
      tar.input.clearable = value
    },
    max(value, opt, tar, node) {
      // TODO:未完成
    },
    min(value, opt, tar, node) {
      // TODO:未完成
    },
    editable(value, opt, tar, node) {
      // TODO:未完成
    },
    shortcut(value, opt, tar, node) {
      // TODO:未完成
    },
  },
}

export default class DatePicker extends Basic {
  constructor(opt) {
    super(opt)
    const def = {
      type: 'datepicker', // 控件类型
      mode: 'D', // 控件输入格式
      placeholder: '', // 原生属性: 占位文字
    }
    this.defaults = {
      name: '', // 原生属性: 控件名
      disabled: false, // 原生属性: disabled

      size: '', // 基本功能: 尺寸
      showIcon: true, // 基本功能: 是否显示input的前置图标
      date: new Date(), // 基本功能: 设置时间

      isRange: false, // 扩展功能: 范围时间选择
      clearable: true, // 扩展功能: 是否可清空(true/false)
      max: null, // 扩展功能: 最大时间
      min: null, // 扩展功能: 最小时间
      editable: false, // 扩展功能: 文本框可输入
      shortcut: false, // 扩展功能: 左侧快捷键
    }
    this.events = {
      change: 'onChange', // input的值变化事件
      focus: 'onFocus', // input的获得焦点事件
      click: null, // input的点击事件
      shown: null, // 弹窗panel出现后事件
      hidden: null, // 弹窗panel隐藏后事件
    }
    this.settings = Object.assign({}, def, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    // TODO: 为datepicker 多选留的位置
    // const { type } = opt
    // let template
    // if (type === 'text') template = this.unit = util.template.text(opt, this)
    // const members = {}
    // if (template) core.compileSymbol(template[0], members)
    // this.members = members
    this.input = util.pullInput(opt, this)
    this.panel = util.pullPanel(opt, this)
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    this.input.change($.proxy(this.change, this))
    this.input.focus($.proxy(this.focus, this))
    this.input.click($.proxy(this.click, this))
    this.panel.click($.proxy(this.handleClick, this))
    this.panel.shown($.proxy(this.handleShown, this))
    this.panel.sure($.proxy(this.handleClick, this))
    this.panel.cancel($.proxy(this.handleClick, this))
    $(window).click($.proxy(this.handleDropdown, this))
  }

  handleClick() {
    const date = this.panel.date
    if (date === null) return
    const { mode } = this.settings
    this.input.value = util.kickFormate(mode, date)
    this.date = date
    this.change()
  }

  handleShown(obj) {
    if (obj.show) {
      this.hasLocation(this.unit, this.panel.unit, window)
      this.panel.level = this.panel.lvl
    } else {
    }
    this.shown()
  }

  handleDropdown(event) {
    if (this.panel.date === null) return
    if (this.disabled || this.disabled === '') return
    const input = $(event.target).closest(this.input.members.input)
    const panel = $(event.target).closest(this.panel.unit)
    let timeIn = []
    if (this.panel.timeIn) {
      timeIn = $(event.target).closest(this.panel.timeIn.panel.unit)
    }
    if (input.length > 0) {
      if (!this.panel.show) {
        this.panel.date = this.panel.oldValue = this.date
        this.panel.show = true
      }
    } else if (panel.length > 0) {
      this.panel.show = this.panel.key
    } else if (timeIn.length > 0) {
      this.panel.show = true
    } else if (event.target.tagName === 'BODY') {
    } else if (this.panel.show) {
      this.panel.show = false
      this.hidden()
    }
  }

  onChange(target) {
    if (target) {
      this.value = target.value
    }
    this.input.focus()
  }

  onFocus() {
    this.panel.show = true
  }

  set value(value) {
    if ($.type(value) === 'string') {
      const { mode } = this.settings
      if (value === '') {
        this.input.value = ''
        this.date = new Date()
        this.panel.unit.find('.current').removeClass('current')
        return
      }
      this.date = util.kickValue(mode, value) // 因mode改变数值
      this.input.value = util.kickFormate(mode, this.date)
    } else {
      this.value = ''
    }
  }

  get value() {
    return this.input.value
  }

  get textContent() {
    return this.input.value
  }
}
